import { cropSlice } from "./slice";

export const {
    setHeight,
    setRatio,
    setWidth,
    setLeft,
    setTop,
    toggleCropOrientation,
    setImage,
    setUploadData,
    setCustomRatioX,
    setCustomRatioY
} = cropSlice.actions;
